// src/services/backupCrc.js
//
// A study's BACKUP CRCs — zero or more names, stored on the study document as
// `BACKUP_CRC: string[]` (sits alongside the single LEAD_CRC string).
//
// Pure and Firebase-free so it is unit-tested (backupCrc.test.js). Readers are
// tolerant of a plain string too — the legacy generic editor (/edit/:id)
// renders every field as a text box, so a value typed there comes back as
// "Ann, Bob" rather than an array.

/** Any stored value -> a clean list of names (no blanks, trimmed). */
export const normalizeBackupCrcs = (value) => {
  if (Array.isArray(value)) return value.map((v) => String(v ?? "").trim()).filter(Boolean);
  if (typeof value === "string") return value.split(",").map((v) => v.trim()).filter(Boolean);
  return [];
};

/** How the list reads on the study page: "Ann, Bob", or "" for none. */
export const formatBackupCrcs = (value) => normalizeBackupCrcs(value).join(", ");

/**
 * The editor always shows at least one box, so a study with no backups still
 * offers a place to type one.
 */
export const backupCrcRows = (value) => {
  const list = normalizeBackupCrcs(value);
  return list.length ? list : [""];
};
